/**
 * Agent log API wrapper. Returns a paginated envelope (`Paginated<AgentLogDTO>`).
 */
import { api } from '@/utils/api';
import type { AgentDailyReport, AgentLogDTO, Paginated } from '@shared/types';

/** Params accepted by {@link list}. */
export interface LogListParams {
  adAccountId?: string;
  campaignId?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}

/** List agent activity logs (paginated), optionally filtered. */
export async function list(params?: LogListParams): Promise<Paginated<AgentLogDTO>> {
  const response = await api.get<Paginated<AgentLogDTO>>('/logs', {
    params: {
      ad_account_id: params?.adAccountId,
      campaign_id: params?.campaignId,
      start_date: params?.startDate,
      end_date: params?.endDate,
      limit: params?.limit,
      offset: params?.offset,
    },
  });
  return response.data;
}

/** Today's agent + business digest ("Báo cáo hôm nay"). */
export async function report(): Promise<AgentDailyReport> {
  const response = await api.get<AgentDailyReport>('/logs/report');
  return response.data;
}

export default { list, report };
